import React from 'react';
import {
    financialStatusStyle,
    financialTitleContainerStyle,
    financialTitleStyle,
    financialValueStyle,
    financialValueVerticalStyle
} from './BillingStyles';

const FinancialPerformance = ({ campaign, staticData, width, height }) => {
    return (
        <div>
            <div style={financialTitleContainerStyle}>
                <span style={financialTitleStyle}>Financial Performance</span>
            </div>
            <div style={financialStatusStyle(campaign?.financialPerformance)}>
                <div align='center' style={financialValueVerticalStyle}>
                    <span style={financialValueStyle}>
                        {`${campaign?.financialPerformance || 0}%`}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default FinancialPerformance;
